import React, { Component } from 'react'
import {
  Title,
  Subtitle,
  Input,
  Paragraph,
  TextArea,
  CreateBtn,
  DatePicker,
  TimePicker,
  UploadBtn,
  SmallBtn
} from '../../components/Regular/index'
import { SubConferenceTable } from '../../components/Table/index'

import Search from '../../components/Search/Search'
import swal from 'sweetalert'

import moment from 'moment'

export default class CreateConference extends Component {

  constructor(props) {
    super(props)

    this.state = {
      // date picker state
      date: null,
      hh: '00',
      mm: '00',
      focused: false,

      // sub_conference
      sub_title: '',
      pdf: null,
      filename: '',
    }

  }


  render() {
    const { date, focused, sub_title, time, filename, pdf, hh, mm } = this.state
    const { goNext,
      // left
      title,
      onChageTitle,
      detail,
      onChageDetail,
      // right
      sub_conference,
      handleAddSub,
      handleRemoveSub,
      btnLoading,
      token,
    } = this.props

    return (
      <div className='container' >
        <div className='create-container' >

          {/* ====================== Create Left ============================ */}
          <div className='create-left' >
            <Title text={'สร้างการประชุม'} />
            <Subtitle text='ข้อมูลการประชุม' marginTop={20} />
            <Paragraph text='ชื่อการประชุม' />
            <Input marginTop={16} name='title' value={title} onChange={onChageTitle} />
            <Paragraph text='รายละเอียดการประชุม' marginTop={10} />
            <TextArea lines={18} marginTop={16} name='detail' value={detail} onChange={onChageDetail} />
            {/* <CreateBtn text='เพิ่มหัวข้อการประชุม' marginTop={40} /> */}
          </div>

          {/* ===================== Create Right =========================== */}
          <div className='create-right' >
            <Search marginTop={22} />
            <Subtitle text='เพิ่มการประชุม' marginTop={38} />
            {/* date picker */}
            <div style={{ display: 'flex', flexDirection: 'row' }} >
              <div style={{ flex: 2 }} >
                <Paragraph text='ชื่อวาระประชุม' />
                <Input marginTop={16} name='sub_title' value={sub_title} onChange={this.onChange} />
              </div>
              <div style={{ flex: 1, marginLeft: 30 }} >
                <Paragraph text='วันที่ประชุม' marginBottom={16} />
                <DatePicker _onChange={this._onChange} date={date} focused={focused} _onFocusedChange={this._onFocusedChange} />
              </div>
            </div>

            {/* upload file */}
            <div style={{ display: 'flex', flexDirection: 'row' }} >
              <div style={{ flex: 1 }} >
                <Paragraph text='อัปโหลดเอกสาร' marginTop={10} />
                <UploadBtn marginTop={10} name='pdf' onChange={this._handleFileUpload} filename={filename} />
              </div>

              <div style={{ flex: 1 }} >
                <Paragraph text='เวลาที่ประชุม' marginTop={10} marginLeft={30} />
                <TimePicker marginTop={10} marginLeft={28} _handleChange={this._onChange} hh={hh} mm={mm} />
                <SmallBtn title='+ เพิ่มหัวข้อ' loading={btnLoading} marginTop={16} marginLeft={30} onClick={this._handleAddSub} />
              </div>

            </div>

            <Subtitle text='วาระการประชุม' />
            <SubConferenceTable subCF={sub_conference} onDelete={handleRemoveSub} token={token} />

            {/* go next */}

          </div>

        </div>
        <CreateBtn text='ดำเนินการต่อ' onClick={goNext} marginBottom={40} />
      </div>

    )
  }

  _onChange = key =>
    value => this.setState({ [key]: value })

  onChange = e => this.setState({ [e.target.name]: e.target.value })

  _onFocusedChange = ({ focused }) => this.setState({ focused })

  _handleFileUpload = e => {
    this.setState({ [e.target.name]: e.target.files[0], filename: e.target.files[0].name })

  }

  _handleAddSub = () => {
    const { sub_title, date, hh, mm, pdf } = this.state
    const { handleAddSub } = this.props
    const dateL = moment(this.state.date).format('YYYY-MM-DD').split('-')
    const meeting_time = `${Number(dateL[0]) + 543}-${dateL[1]}-${dateL[2]} ${hh}:${mm}:00`

    if (sub_title && date && pdf) {
      handleAddSub(sub_title, meeting_time, pdf)
      this.setState({ sub_title: '', pdf: '', filename: '' })
    } else {
      swal('กรุณาตรวจสอบข้อมูลก่อนเพิ่มหัวข้อ', '', 'warning')
    }

  }

}



// WEBPACK FOOTER //
// ./src/pages/Main/CreateConference.js